import { IGenericResponse } from "src/apis/helpers/baseModels/IGenericResponse";
import { Api } from "src/apis/helpers/configs/api";
import { ContactUsDto } from "src/data/models/contactUsDtos/contactUsDto.interface";
import { SettingDto } from "src/data/models/settingDtos/settingDto.interface";
import { SliderDto } from "src/data/models/sliderDtos/sliderDto.interface";
import BaseRepository from "../Base/BaseRepository";
import IBaseDataRepository from "./IBaseDataRepository";

export default class BaseDataRepository extends BaseRepository implements IBaseDataRepository {

  async getSetting(): Promise<IGenericResponse<SettingDto>> {
    const request = this.CreateRequestBuilder()
      .setMethod('get')
      .setUrl(Api.BaseData.getSetting)

    return await request
      .GetResultAsync()
  }

  async editSetting(body: SettingDto): Promise<IGenericResponse<SettingDto>> {
    const request = this.CreateRequestBuilder()
      .setMethod('put')
      .setBody(body)
      .setUrl(Api.BaseData.editSetting)

    return await request
      .GetResultAsync()
  }

  async getSliders(): Promise<IGenericResponse<SliderDto[]>> {
    const request = this.CreateRequestBuilder()
      .setMethod('get')
      .setUrl(Api.BaseData.getSliders)

    return await request
      .GetResultAsync()
  }

  async getContactUs(): Promise<IGenericResponse<ContactUsDto[]>> {
    const request = this.CreateRequestBuilder()
      .setMethod('get')
      .setUrl(Api.BaseData.getContactUs)

    return await request
      .GetResultAsync()
  }

  async getSlider(id: any): Promise<IGenericResponse<SliderDto>> {
    const request = this.CreateRequestBuilder()
      .setMethod('get')
      .addQueryParam('id', id)
      .setUrl(Api.BaseData.getSlider)

    return await request
      .GetResultAsync()
  }

  async addSlider(body: SliderDto): Promise<IGenericResponse<SliderDto>> {
    const request = this.CreateRequestBuilder()
      .setMethod('post')
      .setBody(body)
      .setUrl(Api.BaseData.addSlider)

    return await request
      .GetResultAsync()
  }

  async editSlider(body: SliderDto): Promise<IGenericResponse<SliderDto>> {
    const request = this.CreateRequestBuilder()
      .setMethod('put')
      .setBody(body)
      .setUrl(Api.BaseData.editSlider)

    return await request
      .GetResultAsync()
  }

  async deleteSlider(sliderId: number): Promise<IGenericResponse<number>> {
    const request = this.CreateRequestBuilder()
      .setMethod('delete')
      .setUrl(Api.BaseData.deleteSlider, { sliderId })

    return await request
      .GetResultAsync()
  }


}
